import React, { useState, Fragment } from 'react';
import * as Yup from 'yup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Alerts from '../../utils/alerts';

import Documents from './Documents';
import ResultsInfra from './ResultsInfra';
import ResultsEquipment from './ResultsEquipment';

import Add from '@material-ui/icons/AddCircleOutline';
import { MdSave } from 'react-icons/md';
import { MdOutlineFileUpload } from 'react-icons/md';
import { MdFileDownload } from 'react-icons/md';
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { AiOutlineFileProtect } from "react-icons/ai";
import { BsHddNetworkFill } from "react-icons/bs";

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Button,
    TextField,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    Switch,
    Paper,
    FormLabel,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    Icon,
    ListItemText,
    ListItemIcon
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.blue[400],
        '&$checked': {
            color: colors.blue[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    doned: {
        padding: 5
    },
    container: {
        minHeight: 640
    },
    grouplabel: {
        color: colors.blue[300]
    },
    groupdivider: {
        borderTop: `1px solid ${colors.blue[300]}`
    },
    lists: {
        maxHeight: 560
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

function TabPanel(props) {
    const { children, value, index, selectedMode, ...other } = props;

    return (
        <div
            margin="0px"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box
                    marginTop={2}
                    marginBottom={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 2 : 0}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const infraColumns = [
    { name: 'Nome', field: 'item.infraEstrutura.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Tipo de Infraestrutura', field: 'item.infraEstrutura.tipo.nome', size: -1, sortable: 0, exportable: 0 },
    { name: 'Quantidade', field: 'formatNumber(item.qtd, "0")', size: -1, sortable: 0, exportable: 0 },
    { name: 'Observações', field: 'item.detalhes', size: 500, sortable: 0, exportable: 0 }
];

const equipmentColumns = [
    { name: 'Modelo', field: 'item.modelo', size: 300, sortable: 0, exportable: 0 },
    { name: 'Tipo', field: 'item.tipo.nome', size: 100, sortable: 0, exportable: 0 },
    { name: 'Marca', field: 'item.marca.nome', size: 200, sortable: 0, exportable: 0 },
    { name: 'Observações', field: 'item.observacoes', size: 400, sortable: 0, exportable: 0 }
];

const infraEmptyMessage = "Nenhuma Infraestrutura foi Adicionada.";
const equipmentEmptyMessage = "Nenhum Equipamento foi Adicionado.";

const infraFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_ENABLED,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: infraEmptyMessage,
    columns: infraColumns
};

const infraCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_ENABLED,
    update: LEVEL_ACCESS_ENABLED,
    delete: LEVEL_ACCESS_ENABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: infraEmptyMessage,
    columns: infraColumns
};

const equipmentFullMode = {
    mode: MODE_FULL,
    create: LEVEL_ACCESS_DISABLED,
    update: LEVEL_ACCESS_DISABLED,
    delete: LEVEL_ACCESS_DISABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: equipmentEmptyMessage,
    columns: equipmentColumns
};

const equipmentCompactMode = {
    mode: MODE_COMPACT,
    create: LEVEL_ACCESS_DISABLED,
    update: LEVEL_ACCESS_DISABLED,
    delete: LEVEL_ACCESS_DISABLED,
    config: LEVEL_ACCESS_HIDE,
    export: LEVEL_ACCESS_HIDE,
    empty: equipmentEmptyMessage,
    columns: equipmentColumns
};


const infraResultModes = [infraFullMode, infraCompactMode];
const equipmentResultModes = [equipmentFullMode, equipmentCompactMode];


const Unit = ({ item, open, closeEdition, selectedMode, dependencies, updateValues, openUpload, openDocumentEdition,
    openDeletionDocument, openDeletionInfra, openInfraEdition, openInfraCreation, checked, handleToggle, updateDependencies }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [openDocuments, setOpenDocuments] = useState(true);
    const [value, setValue] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };

    const changeEmpresa = (event, values) => {
        values = {
            ...values,
            empresa: event.target.value,
            ENGENHEIRO: null,
            REGIAO: null,
            EQUIPE: null,
            gso: null,
            gerenciadora: null,
            tipo: null,
            TIPO: null,
            GERENCIADORA: null
        };
        updateDependencies(values);
    }

    const changeUF = (event, values) => {
        values = { ...values, uf: event.target.value, MUNICIPIO: null, municipio: {} };
        updateDependencies(values);
    };

    const changeEquipe = (event, values) => {
        values = { ...values, EQUIPE: event.target.value, REGIAO: null };
        updateDependencies(values);
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth   >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Unidade
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('A seleção da unidade é obrigatório'),
                                nome: Yup.string().required('O nome da unidade é obrigatório'),
                                TIPO: Yup.string().required('O Tipo de unidade é obrigatório'),
                                MUNICIPIO: Yup.string().required('O Município da unidade é obrigatório'),
                                empresa: Yup.string().required('O Cliente da unidade é obrigatório'),
                                REGIAO: Yup.string().required('A Rota é obrigatório'),
                                EQUIPE: Yup.string().required('A Equipe é obrigatória'),
                                ENGENHEIRO: Yup.string().required('O Engenheiro Responsável é obrigatório'),
                                GERENCIADORA: Yup.string().required('A Gerenciadora é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <AppBar position="relative" >
                                    <Tabs
                                        value={value}
                                        onChange={handleChangeTab}
                                        aria-label="tabs"
                                        variant="scrollable"
                                        scrollButtons="auto">

                                        <Tab label="Localização" {...a11yProps(0)} />
                                        <Tab label="Infraestrutura" {...a11yProps(1)} />
                                        <Tab label="Equipamentos" {...a11yProps(2)} />
                                        <Tab label="AVCB" {...a11yProps(3)} />
                                        <Tab label="Contratos" {...a11yProps(4)} />
                                    </Tabs>
                                </AppBar>

                                <TabPanel value={value} index={0} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >
                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.codigo && errors.codigo)}
                                                    fullWidth
                                                    required
                                                    label="Código"
                                                    margin="none"
                                                    name="codigo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.codigo}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    fullWidth
                                                    required
                                                    label="Nome"
                                                    margin="none"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none">
                                                    <InputLabel shrink htmlFor="empresa" required>Cliente</InputLabel>
                                                    <Select
                                                        notched
                                                        shrink
                                                        autosize={true}
                                                        error={Boolean(touched.empresa && errors.empresa)}
                                                        helperText={touched.empresa && errors.empresa}
                                                        value={values.empresa}
                                                        onChange={e => {
                                                            handleChange(e);
                                                            changeEmpresa(e, values);
                                                        }}
                                                        onBlur={handleBlur}
                                                        label="Cliente"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'empresa',
                                                            id: 'empresa'
                                                        }}

                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.companies.map((empresa) => (
                                                            <MenuItem key={empresa.id} value={empresa.id}>{empresa.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth >
                                                    <InputLabel shrink htmlFor="TIPO" required >Tipo de Unidade</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.TIPO && errors.TIPO)}
                                                        helperText={touched.TIPO && errors.TIPO}
                                                        value={values.TIPO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Tipo de Ocorrência"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'TIPO',
                                                            id: 'TIPO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.types.map((tipo) => (
                                                            <MenuItem key={tipo.id} value={tipo.id}>{tipo.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="ENGENHEIRO" required>Engenheiro responsável</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.ENGENHEIRO && errors.ENGENHEIRO)}
                                                        helperText={touched.ENGENHEIRO && errors.ENGENHEIRO}
                                                        value={values.ENGENHEIRO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Engenheiro responsável"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'ENGENHEIRO',
                                                            id: 'ENGENHEIRO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.engineers.map((engenheiro) => (
                                                            <MenuItem key={engenheiro.id} value={engenheiro.id}>{engenheiro.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="GERENCIADORA" required>Gerenciadora</InputLabel>
                                                    <Select
                                                        notched
                                                        autosize={true}
                                                        error={Boolean(touched.GERENCIADORA && errors.GERENCIADORA)}
                                                        helperText={touched.GERENCIADORA && errors.GERENCIADORA}
                                                        value={values.GERENCIADORA}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Gerenciadora"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'GERENCIADORA',
                                                            id: 'GERENCIADORA',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.controllers.map((gerenciadora) => (
                                                            <MenuItem key={gerenciadora.id} value={gerenciadora.id}>{gerenciadora.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.fiscal && errors.fiscal)}
                                                    fullWidth
                                                    label="Fiscal"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                    multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                    margin="none"
                                                    name="fiscal"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.fiscal}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="atendType" required>Rota</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.REGIAO && errors.REGIAO)}
                                                        helperText={touched.REGIAO && errors.REGIAO}
                                                        value={values.REGIAO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Rota"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'REGIAO',
                                                            id: 'REGIAO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.regions.map((regiao) => (
                                                            <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="atendType" required>Equipe Técnica</InputLabel>
                                                    <Select
                                                        notched
                                                        required
                                                        autosize={true}
                                                        error={Boolean(touched.EQUIPE && errors.EQUIPE)}
                                                        helperText={touched.EQUIPE && errors.EQUIPE}
                                                        value={values.EQUIPE}
                                                        onChange={e => {
                                                            handleChange(e);
                                                            changeEquipe(e, values);
                                                        }}
                                                        onBlur={handleBlur}
                                                        label="Equipe Técnica"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'EQUIPE',
                                                            id: 'EQUIPE',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.teams.map((equipe) => (
                                                            <MenuItem key={equipe.id} value={equipe.id}>{equipe.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="gso">GSO</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.gso && errors.gso)}
                                                        helperText={touched.gso && errors.gso}
                                                        value={values.gso}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="GSO"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'gso',
                                                            id: 'gso',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.managers.map((gso) => (
                                                            <MenuItem key={gso.id} value={gso.id}>{gso.regional}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.cnpj && errors.cnpj)}
                                                    fullWidth
                                                    label="CNPJ"
                                                    margin="none"
                                                    name="cnpj"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.cnpj}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={8}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.endereco && errors.endereco)}
                                                    fullWidth
                                                    label="Endereço"
                                                    margin="none"
                                                    name="endereco"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.endereco}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.bairro && errors.bairro)}
                                                    fullWidth
                                                    label="Bairro"
                                                    margin="none"
                                                    name="bairro"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.bairro}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="uf">UF</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.uf && errors.uf)}
                                                        helperText={touched.uf && errors.uf}
                                                        value={values.uf}
                                                        onChange={e => {
                                                            handleChange(e);
                                                            changeUF(e, values);
                                                        }}
                                                        onBlur={handleBlur}
                                                        label="UF"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'uf',
                                                            id: 'uf',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.states.map((uf) => (
                                                            <MenuItem key={uf.UF} value={uf.UF}>{uf.UF}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="MUNICIPIO">Município</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.MUNICIPIO && errors.MUNICIPIO)}
                                                        helperText={touched.MUNICIPIO && errors.MUNICIPIO}
                                                        value={values.MUNICIPIO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Município"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'MUNICIPIO',
                                                            id: 'MUNICIPIO',
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.cyties.map((municipio) => (
                                                            <MenuItem key={municipio.id} value={municipio.id}>{municipio.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.cep && errors.cep)}
                                                    fullWidth
                                                    label="CEP"
                                                    margin="none"
                                                    name="cep"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.cep}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.telefone && errors.telefone)}
                                                    fullWidth
                                                    label="Telefone"
                                                    margin="none"
                                                    name="telefone"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.telefone}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.latitude && errors.latitude)}
                                                    fullWidth
                                                    helperText={touched.latitude && errors.latitude}
                                                    label="Latitude no Mapa"
                                                    margin="none"
                                                    name="latitude"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.latitude}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <TextField
                                                    error={Boolean(touched.longitude && errors.longitude)}
                                                    fullWidth
                                                    helperText={touched.longitude && errors.longitude}
                                                    label="Longitude no Mapa"
                                                    margin="none"
                                                    name="longitude"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.longitude}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <Typography
                                                    color="textPrimary"
                                                    gutterBottom
                                                    variant="h6"
                                                >
                                                    Ativa / Inativa
                                                </Typography>
                                                <Switch
                                                    checked={values.ativa}
                                                    onChange={handleChange}
                                                    name="ativa" />
                                            </Grid>


                                            <Grid
                                                item
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.obs && errors.obs)}
                                                    fullWidth
                                                    helperText="Coloque aqui comentário ou justificativa a respeito da unidade (1024 caracteres)."
                                                    label="Observações sobre a Unidade"
                                                    rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 5 : 1}
                                                    size={10}
                                                    length={1024}
                                                    multiline
                                                    margin="none"
                                                    name="obs"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.obs}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={value} index={1} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid item
                                                md="auto"
                                                xs="auto"
                                            >
                                                {(infraResultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                                                    <Box mt={2} >
                                                        <Button
                                                            color="secondary"
                                                            disabled={infraResultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                                                            size="small"
                                                            variant="contained"
                                                            startIcon={<Add />}
                                                            onClick={() => { openInfraCreation(item) }}>
                                                            Adicionar Infraestrutura
                                                        </Button>
                                                    </Box>
                                                ) : ('')}

                                            </Grid>

                                        </Grid>
                                        <br></br>
                                        <ResultsInfra
                                            resultset={{
                                                loaded: true,
                                                records: dependencies.infrasUnidade.length,
                                                pages: 1,
                                                page: 1,
                                                count: dependencies.infrasUnidade.length,
                                                rows: dependencies.infrasUnidade
                                            }}
                                            resultModes={infraResultModes}
                                            icon={MdOutlineMapsHomeWork}
                                            vision={{}}
                                            selectedMode={selectedMode}
                                            openEdition={openInfraEdition}
                                            openDeletion={openDeletionInfra}
                                            openTreatment={() => { }}
                                            openExportDialog={false}
                                            values={values}
                                        />

                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={2} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid item
                                                md="auto"
                                                xs="auto"
                                            >
                                                {(equipmentResultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                                                    <Box mt={2} >
                                                        <Button
                                                            color="secondary"
                                                            disabled={equipmentResultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                                                            size="small"
                                                            variant="contained"
                                                            startIcon={<Add />}
                                                            onClick={() => { openInfraCreation(item) }}>
                                                            Adicionar Equipamento
                                                        </Button>
                                                    </Box>
                                                ) : ('')}

                                            </Grid>

                                        </Grid>
                                        <br></br>
                                        <ResultsEquipment
                                            resultset={{
                                                loaded: true,
                                                records: dependencies.equipments.length,
                                                pages: 1,
                                                page: 1,
                                                count: dependencies.equipments.length,
                                                rows: dependencies.equipments
                                            }}
                                            resultModes={equipmentResultModes}
                                            icon={BsHddNetworkFill}
                                            vision={{}}
                                            selectedMode={selectedMode}
                                            openEdition={() => { }}
                                            openDeletion={() => { }}
                                            openTreatment={() => { }}
                                            openExportDialog={() => { }}
                                            values={values}
                                        />

                                    </Box>
                                </TabPanel>

                                <TabPanel value={value} index={3} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid item
                                                md="auto"
                                                xs={12}>
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting || dependencies.documents.length == 0}
                                                    size="small"
                                                    startIcon={<MdFileDownload />}
                                                    variant="contained"
                                                    href={process.env.REACT_APP_AGM_ENDPPOINT + "/documentosunidade/zip/" + values.id + ',' + values.codigo}>
                                                    Baixar Documentos
                                                </Button>

                                            </Grid>
                                            <Grid item
                                                md="auto"
                                                xs={12}>
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    startIcon={<MdOutlineFileUpload />}
                                                    variant="contained"
                                                    onClick={() => { openUpload(values) }}>
                                                    Enviar Documentos
                                                </Button>
                                            </Grid>

                                            <Grid item
                                                xs="auto">
                                                <Typography variant='h4' color='secondary' ><b>[ {(dependencies.documents.length) == 1 ? ('1 Documento') : (dependencies.documents.length + ' Documentos')} ]</b></Typography>
                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>
                                                <Divider className={classes.groupdivider}></Divider>
                                            </Grid>

                                            <Grid item
                                                md={12}
                                                xs={12}>

                                                <Documents
                                                    documents={dependencies.documents}
                                                    openDocumentEdition={openDocumentEdition}
                                                    openDeletionDocument={openDeletionDocument}
                                                    openUpload={openUpload}
                                                    values={values}
                                                />
                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={value} index={4} selectedMode={selectedMode}>

                                    <Box className={classes.container} >

                                        <Grid
                                            container
                                            spacing={2}
                                            className={classes.doned}
                                        >

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}  >

                                                <Paper variant="outlined" rounded fullWidth  >
                                                    <FormControl component="fieldset" fullWidth  >
                                                        <FormLabel style={{ padding: 10 }} >
                                                            <b>Contratos Associados a Unidade</b>
                                                        </FormLabel>

                                                        <Divider></Divider>

                                                        <List dense button component={PerfectScrollbar} className={classes.lists} >
                                                            {dependencies.contracts.map((contract, index) => {
                                                                return (
                                                                    <ListItem key={index} autoFocus={true}>
                                                                        <ListItemIcon>
                                                                            <ColorCheckbox
                                                                                edge="end"
                                                                                onChange={handleToggle(contract.id, 'contracts')}
                                                                                checked={checked.indexOf(contract.id) != -1}
                                                                                inputProps={{ 'aria-labelledby': contract.id }}
                                                                            />
                                                                        </ListItemIcon>
                                                                        <ListItemAvatar>
                                                                            <Avatar
                                                                                className={classes.avatar}
                                                                            >
                                                                                {<Icon component={AiOutlineFileProtect} style={{ color: colors.cyan[400] }} ></Icon>}
                                                                            </Avatar>
                                                                        </ListItemAvatar>
                                                                        <ListItemText id={contract.id} primary={contract.nome} />
                                                                    </ListItem>
                                                                );
                                                            })}

                                                        </List>
                                                    </FormControl>
                                                </Paper>
                                            </Grid>

                                        </Grid>
                                    </Box>

                                </TabPanel>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                startIcon={<MdSave />}
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Unit;
